export const getCrossTableData = (
  mainQuestinNumber,
  crossQuestionNumber,
  crossTabs,
  cluster
) => {
  try {
    let targetRowNumber = 0;
    let targetCrossTab = crossTabs.find(
      (t) =>
        t.question_row.number === mainQuestinNumber &&
        t.question_column.number === crossQuestionNumber
    );
    if (cluster) {
      targetRowNumber = targetCrossTab.question_column.answers
        .map(function (e) {
          return e.desc;
        })
        .indexOf(cluster);
    }
    let tempArray = [];
    tempArray.push(targetCrossTab.answer_dataset[targetRowNumber]);

    let tempPercents = [];
    for (
      let i = 0;
      i < targetCrossTab.row_percents[targetRowNumber].length;
      i++
    ) {
      tempPercents[i] = (
        targetCrossTab.row_percents[targetRowNumber][i] * 100
      ).toFixed(1);
    }
    tempArray.push(tempPercents);

    let tempErrors = [];
    for (let i = 0; i < targetCrossTab.row_errors.length; i++) {
      tempErrors[i] = (targetCrossTab.row_errors[i] * 100).toFixed(1);
    }

    tempArray.push(tempErrors);

    let signifs = [];
    for (
      let i = 0;
      i < Object.keys(targetCrossTab.class_signifs_array).length;
      i++
    ) {
      signifs[i] = targetCrossTab.class_signifs_array[i][
        targetRowNumber
      ].replace(/r/g, "c");
    }
    tempArray.push(signifs);

    let tempRanges = [];
    for (let i = 0; i < tempPercents.length; i++) {
      let underlimit = Number(tempPercents[i]) - Number(tempErrors[i]);
      let upperlimit = Number(tempPercents[i]) + Number(tempErrors[i]);
      tempRanges[i] =
        (underlimit > 0 ? underlimit.toFixed(1) : 0) +
        " ~ " +
        (upperlimit > 0 ? upperlimit.toFixed(1) : 0);
    }
    tempArray.push(tempRanges);

    let tempSum = [];
    tempSum.push(targetCrossTab.column_totals[targetRowNumber]);
    tempSum.push(
      (targetCrossTab.column_total_percents[targetRowNumber] * 100).toFixed(1)
    );
    tempSum.push(
      (targetCrossTab.column_errors[targetRowNumber] * 100).toFixed(1)
    );
    tempSum.push("");

    var underRange = (Number(tempSum[1]) - Number(tempSum[2])).toFixed(1);
    var upperRange = (Number(tempSum[1]) + Number(tempSum[2])).toFixed(1);
    var range =
      (underRange > 0 ? underRange : 0) +
      " ~ " +
      (upperRange > 0 ? upperRange : 0);

    tempSum.push(range);

    let returnArray = [];
    tempRanges.forEach((element) => {
      returnArray.push([]);
    });

    for (let i = 0; i < tempArray.length; i++) {
      for (let j = 0; j < tempArray[i].length; j++) {
        returnArray[j][i] = tempArray[i][j];
      }
    }
    returnArray.push(tempSum);

    // For Counts = 0, do not show Error and Range
    for (let i = 0; i < returnArray.length; i++) {
      if (returnArray[i][0] === 0) {
        returnArray[i][2] = null;
        returnArray[i][4] = null;
      }

      // If Error is less than 0 then set Error = 0
      if (Number(returnArray[i][2]) < 0) {
        returnArray[i][2] = 0;
      }
    }
    return returnArray;
  } catch (err) {
    return [];
  }
};
